import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation-burger",
  "use": "navigation-burger-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"navigation-burger\">\n    <rect x=\"8\" y=\"10\" width=\"20\" height=\"2\" rx=\"1\" fill=\"#4C4C4C\" />\n    <rect x=\"8\" y=\"17\" width=\"20\" height=\"2\" rx=\"1\" fill=\"#4C4C4C\" />\n    <rect x=\"8\" y=\"24\" width=\"20\" height=\"2\" rx=\"1\" fill=\"#4C4C4C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol